// Tabs — controlled tab strip with underline indicator.
// items: Array<{ id: string; label: string }>

export default function Tabs({ items = [], activeId, onChange }) {
  return (
    <div
      role="tablist"
      style={{
        display: 'flex',
        gap: 24,
        borderBottom: '1px solid var(--olv-panel-border)',
        fontFamily: 'var(--font-mono)',
      }}
    >
      {items.map((tab) => {
        const active = tab.id === activeId
        return (
          <button
            key={tab.id}
            role="tab"
            aria-selected={active}
            type="button"
            onClick={() => onChange?.(tab.id)}
            style={{
              padding: '10px 0',
              background: 'none',
              border: 'none',
              borderBottom: '2px solid',
              borderColor: active ? 'var(--olv-purple)' : 'transparent',
              color: active ? 'var(--olv-text-primary)' : 'var(--olv-text-tertiary)',
              fontSize: 11,
              letterSpacing: '0.10em',
              textTransform: 'uppercase',
              cursor: 'pointer',
              transition: 'color 200ms var(--ease-standard), border-color 200ms var(--ease-standard)',
            }}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
